import React, { useState, useContext } from "react";
import { NavLink } from "react-router-dom";
import Box from "@material-ui/core/Box";
import KeyboardArrowDown from "@material-ui/icons/KeyboardArrowDown";
import KeyboardArrowUp from "@material-ui/icons/KeyboardArrowUp";
import { WebContext } from "../../../../../Utility";
import useStyles from "./styles";
import { useTheme } from "@material-ui/core/styles";
import LocalStorage from "../../../../../LocalStorage";
import { withStyles } from '@material-ui/core/styles';
import Drawer  from "@material-ui/core/Drawer";
import { NewButtonLogin } from "../../../Commons/AnimationButton";
export const StyledDrawer = withStyles((theme) => ({
  root: {
    position: "relative !important",
  },
  paperAnchorLeft: {
    width: "70%",
    height: "100vh",
    backgroundColor: theme?.agentTheme?.primary?.main,
    [theme.breakpoints.up("sm")]: {
      width: "40%",
    },
  },
}))((props) => <Drawer {...props} />);

const MobileNavDrawer = ({
  showDrawer = false,
  setShowDrawer = () => {},
  contentArr = [],
  handleLogoutClick = () => {},
  widgetList = [],
  loginItem = [],
}) => {
  let user = LocalStorage.getUser();
  const [loginOpen, setLoginOpen] = useState(false);
  let { username = "" } = user || {};
  const classes = useStyles();
  const theme = useTheme();
  const { isLoggedIn = false } = useContext(WebContext);
  const [showLogin, setShowLogin] = useState(false);
  const [expandedDropdowns, setExpandedDropdowns] = useState({});

  let [{ component: LoginComponent = null } = {}] = widgetList.filter(
    (widget) => widget.id == "loginModal"
  );

  const toggleDropdown = (itemId) => {
    setExpandedDropdowns((prev) => ({
      ...prev,
      [itemId]: !prev[itemId],
    }));
  };

  const renderNavItem = (item, index) => {
    if (!item) return null;

    if (item.dropdown && item.clickItem && Array.isArray(item.clickItem)) {
      const isExpanded = expandedDropdowns[item.id || index];

      return (
        <React.Fragment key={`dropdown-${index}`}>
          <Box className={classes.navContentContainer}>
            <div
              onClick={() => toggleDropdown(item.id || index)}
              className={classes.contentTextSideNavbar}
              style={{
                color: theme.agentTheme.card.link_foreground,
                cursor: "pointer",
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                padding: "5px 0",
                width: "100%",
              }}
            >
              <span>{(item.label || item.name || "").toUpperCase()}</span>
              {isExpanded ? <KeyboardArrowUp /> : <KeyboardArrowDown />}
            </div>
          </Box>

          {isExpanded &&
            item.clickItem.map((subItem, subIndex) => (
              <Box
                key={`sub-${index}-${subIndex}`}
                className={classes.navContentContainer}
              >
                <NavLink
                  component={"a"}
                  to={
                    typeof subItem.link === "string"
                      ? subItem.link
                      : subItem.link?.pathname || "/"
                  }
                  className={classes.contentTextSideNavbar}
                  style={{
                    color: theme.agentTheme.card.link_foreground,
                    textDecoration: "none",
                    display: "block",
                    padding: "5px 0",
                    paddingLeft: "20px",
                  }}
                >
                  {(subItem.label || subItem.name || "").toUpperCase()}
                </NavLink>
              </Box>
            ))}
        </React.Fragment>
      );
    }

    if (item.link) {
      return (
        <Box key={index} className={classes.navContentContainer}>
          <NavLink
            component={"a"}
            to={
              typeof item.link === "string"
                ? item.link
                : item.link?.pathname || "/"
            }
            className={classes.contentTextSideNavbar}
            style={{
              color: theme.agentTheme.card.link_foreground,
              textDecoration: "none",
              display: "block",
              padding: "5px 0",
            }}
          >
            {(item.label || item.name || "").toUpperCase()}
          </NavLink>
        </Box>
      );
    }

    return (
      <Box key={index} className={classes.navContentContainer}>
        <span
          className={classes.contentTextSideNavbar}
          style={{
            color: theme.agentTheme.card.link_foreground,
            display: "block",
            padding: "5px 0",
          }}
        >
          {(item.label || item.name || "").toUpperCase()}
        </span>
      </Box>
    );
  };

  const renderLoginItem = (username, loginItem, loginOpen, setLoginOpen) => {
    return (
      <React.Fragment>
        <Box className={classes.navContentContainer}>
          <div
            onClick={() => setLoginOpen((prev) => !prev)}
            className={classes.contentTextSideNavbar}
            style={{
              color: theme.agentTheme.card.link_foreground,
              cursor: "pointer",
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              padding: "5px 0",
              width: "100%",
            }}
          >
            <span>{`Hi, ${username}`}</span>
            {loginOpen ? <KeyboardArrowUp /> : <KeyboardArrowDown />}
          </div>
        </Box>

        {loginOpen &&
          loginItem?.map((subItem, subIndex) => (
            <Box
              key={`sub-${subIndex}`}
              className={classes.navContentContainer}
            >
              {subItem.id === "logout" ? (
                <div
                  onClick={handleLogoutClick}
                  className={classes.contentTextSideNavbar}
                  style={{
                    color: theme.agentTheme.card.link_foreground,
                    cursor: "pointer",
                    display: "block",
                    padding: "5px 0",
                    paddingLeft: "20px",
                  }}
                >
                  {(subItem.label || subItem.name || "").toUpperCase()}
                </div>
              ) : (
                <NavLink
                  to={
                    typeof subItem.link === "string"
                      ? subItem.link
                      : subItem.link?.pathname || "/"
                  }
                  className={classes.contentTextSideNavbar}
                  style={{
                    color: theme.agentTheme.card.link_foreground,
                    textDecoration: "none",
                    display: "block",
                    padding: "5px 0",
                    paddingLeft: "20px",
                  }}
                >
                  {(subItem.label || subItem.name || "").toUpperCase()}
                </NavLink>
              )}
            </Box>
          ))}
      </React.Fragment>
    );
  };

  return (
    <>
      <StyledDrawer
        anchor="left"
        open={showDrawer}
        onClose={() => setShowDrawer(false)}
      >
        <Box
          className={classes.mobileNavDrawer}
          style={{
            display: "flex",
            flexDirection: "column",
            height: "100%",
          }}
        >
          <Box style={{ flex: 1, padding: "0" }}>
            {contentArr
              .filter((item) => item.isShow !== false)
              .map((item, index) => renderNavItem(item, index))}
            {!isLoggedIn && (
              <Box
                style={{ marginTop: "20px", margin: "1rem" }}
                onClick={() => setShowLogin(true)}
              >
                <NewButtonLogin name={"LOGIN"} width={"75%"} />
              </Box>
            )}
            {isLoggedIn &&
              renderLoginItem(username, loginItem, loginOpen, setLoginOpen)}
          </Box>
        </Box>
      </StyledDrawer>

      {showLogin && LoginComponent && (
        <LoginComponent onClose={() => setShowLogin(false)} />
      )}
    </>
  );
};

export default MobileNavDrawer;
